import React, { useRef, useState } from 'react';
import { Table } from 'new/elements/Table';
import { getColumns } from './columns';
import { useDistance } from 'new/hooks/useDistance';
import { loadListingRequestDataset, loadDomainItem, fetchDatasetDoc } from 'js/actions';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { DataProductsDrawer } from '../DataProductsDrawer';

interface RequestsTableProps {
  selectedTab: string;
  requestType: string;
  loading: boolean;
  incomingItems: any;
  outgoingItems: any;
}

export function RequestsTable(props: RequestsTableProps) {
  const { selectedTab, requestType, incomingItems, outgoingItems, loading } = props;
  const dispatch = useAppDispatch();
  const containerRef = useRef();
  const distance = useDistance(containerRef, 400);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const rowDataMap = {
    incoming: incomingItems,
    outgoing: outgoingItems,
  };
  const rows = rowDataMap[selectedTab] || [];
  const isPendingListing = selectedTab === 'incoming' && requestType === 'listing';

  const loadData = (requestData) => {
    if (!requestData?.id) return;
    if (isPendingListing) {
      dispatch(loadListingRequestDataset(requestData?.id));
      dispatch(fetchDatasetDoc(requestData?.id));
      return;
    }
    dispatch(loadDomainItem(requestData?.id));
    dispatch(fetchDatasetDoc(requestData?.id));
  };

  const onDetailClicked = (requestData) => {
    loadData(requestData);
    setSelectedRequest(requestData);
  };

  const tableColumns = getColumns(onDetailClicked, selectedTab);

  const onCloseDrawer = () => {
    setSelectedRequest(null);
  };

  return (
    <>
      <DataProductsDrawer
        datasetId={selectedRequest?.id}
        onClose={onCloseDrawer}
        isRequest={true}
      />
      <Table
        height={distance}
        isSkeletonLoadingMode
        loading={loading}
        parentScrollRef={containerRef}
        columns={tableColumns}
        rows={rows}
        emptyStateText="No outgoing access Requests."
      />
    </>
  );
}
